<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><span><i><a id="page_xi"></a>In loving memory of Rudolph Byrd</i></span></span></p>
<p class="ded1a"><span><span><i>so deeply missed</i></span></span></p>
<p class="ded1a"><span><span><i>and of the miracle that was our trust.</i></span></span></p>
<p class="ded1"><span><span><i>And for G. Kaleo Larson</i></span></span></p>
<p class="ded1a"><span><span><i>My working-class hero.</i></span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?3d03d4de